export default "__VITE_ASSET__INkVFjw2__"